<style lang="less" scoped>
    .chart-container{
        position: relative;
        border: 1px solid #dddee1;
        padding-top: 5px;
        .chart{
            margin-top: 10px;
        }
        .ivu-checkbox-wrapper{
            border: 1px solid #dcdee2;
            border-radius: 3px;
            padding: 1px 5px 1px 5px;
            min-height: 24px;
            margin-right: 0;
        }
        .available-days-text{
            display: inline-block;
            vertical-align: middle;
        }
    }
    .data-empty{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 24px;
    }
</style>
<template>
  <div>
    <div class="chart-container line text-center">
      <div class="text-bold line">
        库存情况
      </div>
      <Select
        v-model="params.years"
        size="small"
        multiple
        :max-tag-count="1"
        :style="years_style"
        @on-change="getStockData"
      >
        <Option
          v-for="year in years"
          :key="year"
          :value="year"
        >
          {{ year }}年
        </Option>
      </Select>
      <InputNumber
        v-model="available_days"
        :min="0"
        :max="365"
        size="small"
        :disabled="!stock.avg_out_stock_in_days"
        style="width: 56px"
        @on-change="recoveryDataZoom"
      />
      <span
        v-if="stock.avg_out_stock_in_days"
        class="available-days-text"
      >天预估出库量</span>
      <span
        v-else
        class="available-days-text"
      >暂无法预估平均出库量</span>
      <!--            <Checkbox v-model="show_average" size="small" @on-change="recoveryDataZoom">显示平均值</Checkbox>-->
      <!--            <Checkbox v-model="show_label" size="small" @on-change="recoveryDataZoom">显示数值</Checkbox>-->
      <VeLine
        class="chart"
        :after-set-option="getOption"
        :legend="legend"
        :series="series"
        :x-axis="x_axis"
        :y-axis="{type: 'value'}"
        :data-zoom="data_zoom"
        :mark-point="mark_point"
        :grid="{right: 40}"
        :events="chart_events"
        resizeable
        :loading="loading"
      />
      <div
        v-if="data_empty"
        class="data-empty"
      >
        没有出库数据
      </div>
      <!--            <Spin fix v-if="loading"></Spin>-->
    </div>
  </div>
</template>
<script>
    import VeChart from 'v-charts/lib/chart.common';
    import VeLine from 'v-charts/lib/line.common';
    import 'echarts'
    // import 'echarts/lib/component/axis';
    // import 'echarts/lib/component/markPoint';
    // import 'echarts/lib/component/markArea';
    // import 'echarts/lib/component/dataZoom';
    import 'v-charts/lib/style.css';

    const TruckDataUri = 'data:image/png;base64,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'
    const now = new Date();
    const last_year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    export default {
        components: { VeChart, VeLine },
        props: {
            stock_id: {
                type: Number,
            },
        },
        data (){
            return {
                params: {
                    type: 'day',
                    years: [last_year],
                },
                today: {
                    month: now.getMonth() + 1,
                    day: now.getDate(),
                },
                stock: {},
                loading: false,
                show_average: true,
                show_label: false,
                chart_data: {
                    columns: [],
                    rows: []
                },
                available_days: 30,
                /*chart_setting: {
                    // xAxisType: 'time',
                },*/
                data_zoom: [
                    {
                        type: 'slider',
                        start: 0,
                        end: 20
                    }
                ],
                changed_data_zoom: [
                    {
                        type: 'slider',
                        start: 0,
                        end: 20
                    }
                ],
                chart_events: {
                    datazoom:(e) => {
                        this.changed_data_zoom[0].start = e.start;
                        this.changed_data_zoom[0].end = e.end;
                    }
                },
                data_empty: false,
                x_axis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed']
                },
                ori_series: [
                    {
                        type: 'scatter',
                        name: '入库',
                        data: [20, null, 30, 40]
                    },
                    {
                        type: 'line',
                        name: '库存',
                        data: [30, 60, 100]
                    }
                ]
            }
        },
        computed: {
            years () {
                const years = [];
                for (let i = last_year; i >= 2019; i--){
                    years.push(i);
                }
                return years;
            },
            years_style () {
                return {
                    textAlign: 'left',
                    width: this.params.years.length > 1 ? '160px' : '100px'
                }
            },
            legend () {
                const legend = {data: [], symbolKeepAspect: true};
                this.series.forEach((serie) => {
                    legend.data.push({
                        name: serie.name,
                        icon: 'circle'
                    });
                });
                return legend;
            },
            series () {
                const series = this.$util.clone(this.ori_series);
                series.forEach((serie) => {
                    if (serie.type === 'scatter') {
                        // 只展示一年的数据时，显示卡车图标, 否则只改变symbol大小
                        if (series.length === 2) {
                            Object.assign(serie, {
                                // symbol:'path://M1007.2,744.7h-1c-6.5,0-11.8-5.3-11.8-11.8v-12.4c0-6.5,5.3-11.8,11.8-11.8h1c6.5,0,11.8,5.3,11.8,11.8v12.4c0,6.5-5.3,11.8-11.8,11.8z M634,225.6H48.3c-20.8,0-37.7,16.9-37.7,37.7v358h661.1v-358c0-20.9-16.9-37.7-37.7-37.7z M896.6,681.3h97.8v-111c0-43.7-14.7-58.5-41.6-104.3-30.4-51.8-37.6-84.5-66.9-84.5H698.4c-8.3,0-15,6.7-15,15v225.3h90.8c49.7-0.1,93.9,23.2,122.4,59.5z M989.4,689.9h-98.3l-1.6-2.1,2.1,2.1c-28.5-36.2-72.7-59.5-122.4-59.5h-715c-7.6,0-13.8,6.2-13.8,13.8v96.4c0,7.6,6.2,13.7,13.7,13.7h35.5c4-57.5,51.7-102.9,110.2-102.9S306,696.8,310,754.3h349c4-57.5,51.7-102.9,110.2-102.9s106.2,45.4,110.2,102.9h114.9c4.6,0,8.4-3.8,8.4-8.4V705c0-7.8-5.8-14.1-13.3-15.1z M964.4,544.2H843.3c-3.5,0-6.4-2.9-6.4-6.4V412.9c0-3.5,2.9-6.4,6.4-6.4h45.4c2.2,0,4.3,1.2,5.5,3.1l75.7,124.9c2.6,4.2-0.5,9.7-5.5,9.7zM813.9,544.2h-96c-6.5,0-11.8-5.3-11.8-11.8V418.2c0-6.5,5.3-11.8,11.8-11.8h96c6.5,0,11.8,5.3,11.8,11.8v114.2c0,6.5-5.3,11.8-11.8,11.8z M289.2,751.1c2.9-1,4.6-4,3.8-7l-3.2-11.9c-0.8-3-3.8-4.7-6.8-4.2,2.5-1.7,3.4-5,1.9-7.6l-6.2-10.7c-1.6-2.7-4.9-3.5-7.6-2.2,2-2.3,2.1-5.8-0.1-8l-8.7-8.7c-2.2-2.2-5.7-2.2-8-0.1,1.3-2.7,0.5-6.1-2.2-7.6l-10.7-6.2c-2.7-1.5-5.9-0.6-7.6,1.9,0.6-3-1.2-6-4.2-6.8l-11.9-3.2c-3-0.8-6,0.9-7,3.8-0.3-3-2.6-5.4-5.7-5.4h-12.4c-3.1,0-5.4,2.4-5.7,5.4-1-2.9-4-4.6-7-3.8L168,672c-3,0.8-4.7,3.8-4.2,6.8-1.7-2.5-5-3.4-7.6-1.9l-10.7,6.2c-2.7,1.6-3.5,4.9-2.2,7.6-2.3-2-5.8-2.1-8,0.1l-8.7,8.7c-2.2,2.2-2.2,5.7-0.1,8-2.7-1.3-6.1-0.5-7.6,2.2l-6.2,10.7c-1.5,2.7-0.6,5.9,1.9,7.6-3-0.6-6,1.2-6.8,4.2l-3.2,11.9c-0.8,3,0.9,6,3.8,7-3,0.3-5.4,2.6-5.4,5.7v12.4c0,3.1,2.4,5.4,5.4,5.7-2.9,1-4.6,4-3.8,7l3.2,11.9c0.8,3,3.8,4.7,6.8,4.2-2.5,1.7-3.4,5-1.9,7.6l6.2,10.7c1.6,2.7,4.9,3.5,7.6,2.2-2,2.3-2.1,5.8,0.1,8l8.7,8.7c2.2,2.2,5.6,2.2,8,0.1-1.3,2.7-0.5,6.1,2.2,7.6l10.7,6.2c2.7,1.5,5.9,0.6,7.6-1.9-0.6,3,1.2,6,4.2,6.8l11.9,3.2c3,0.8,6-0.9,7-3.8,0.3,3,2.6,5.4,5.7,5.4H205c3.1,0,5.4-2.4,5.7-5.4,1,2.9,4,4.6,7,3.8l11.9-3.2c3-0.8,4.7-3.8,4.2-6.8,1.7,2.5,5,3.4,7.6,1.9L252,843c2.7-1.6,3.5-4.9,2.2-7.6,2.3,2,5.8,2.1,8-0.1l8.7-8.7c2.2-2.2,2.2-5.6,0.1-8,2.7,1.3,6.1,0.5,7.6-2.2l6.2-10.7c1.5-2.7,0.6-5.9-1.9-7.6,3,0.6,6-1.2,6.8-4.2l3.2-11.9c0.8-3-0.9-6-3.8-7,3-0.3,5.4-2.6,5.4-5.7v-12.4c0.1-3.1-2.3-5.5-5.3-5.8z---M172.376227,772.582842a28,28,0,1,0,52.623121-19.152209,28,28,0,1,0-52.623121,19.152209Z M273.4,735.8c-15-41.3-60.7-62.6-101.9-47.5-41.3,15-62.6,60.7-47.5,101.9,15,41.3,60.7,62.6,101.9,47.5,41.3-15,62.6-60.6,47.5-101.9z,m-55.9,78.8c-28.5,10.4-60-4.3-70.3-32.8-10.4-28.5,4.3-60,32.8-70.3,28.5-10.4,60,4.3,70.3,32.8,10.3,28.4-4.4,59.9-32.8,70.3z M861.3,751.1c2.9-1,4.6-4,3.8-7l-3.2-11.9c-0.8-3-3.8-4.7-6.8-4.2,2.5-1.7,3.4-5,1.9-7.6l-6.2-10.7c-1.6-2.7-4.9-3.5-7.6-2.2,2-2.3,2.1-5.8-0.1-8l-8.7-8.7c-2.2-2.2-5.7-2.2-8-0.1,1.3-2.7,0.5-6.1-2.2-7.6l-10.7-6.2c-2.7-1.5-5.9-0.6-7.6,1.9,0.6-3-1.2-6-4.2-6.8l-11.9-3.2c-3-0.8-6,0.9-7,3.8-0.3-3-2.6-5.4-5.7-5.4h-12.4c-3.1,0-5.4,2.4-5.7,5.4-1-2.9-4-4.6-7-3.8l-11.9,3.2c-3,0.8-4.7,3.8-4.2,6.8-1.7-2.5-5-3.4-7.6-1.9l-10.7,6.2c-2.7,1.6-3.5,4.9-2.2,7.6-2.3-2-5.8-2.1-8,0.1l-8.7,8.7c-2.2,2.2-2.2,5.7-0.1,8-2.7-1.3-6.1-0.5-7.6,2.2l-6.2,10.7c-1.5,2.7-0.6,5.9,1.9,7.6-3-0.6-6,1.2-6.8,4.2l-3.2,11.9c-0.8,3,0.9,6,3.8,7-3,0.3-5.4,2.6-5.4,5.7v12.4c0,3.1,2.4,5.4,5.4,5.7-2.9,1-4.6,4-3.8,7l3.2,11.9c0.8,3,3.8,4.7,6.8,4.2-2.5,1.7-3.4,5-1.9,7.6l6.2,10.7c1.6,2.7,4.9,3.5,7.6,2.2-2,2.3-2.1,5.8,0.1,8l8.7,8.7c2.2,2.2,5.6,2.2,8,0.1-1.3,2.7-0.5,6.1,2.2,7.6l10.7,6.2c2.7,1.5,5.9,0.6,7.6-1.9-0.6,3,1.2,6,4.2,6.8l11.9,3.2c3,0.8,6-0.9,7-3.8,0.3,3,2.6,5.4,5.7,5.4H777c3.1,0,5.4-2.4,5.7-5.4,1,2.9,4,4.6,7,3.8l11.9-3.2c3-0.8,4.7-3.8,4.2-6.8,1.7,2.5,5,3.4,7.6,1.9l10.7-6.2c2.7-1.6,3.5-4.9,2.2-7.6,2.3,2,5.8,2.1,8-0.1l8.7-8.7c2.2-2.2,2.2-5.6,0.1-8,2.7,1.3,6.1,0.5,7.6-2.2l6.2-10.7c1.5-2.7,0.6-5.9-1.9-7.6,3,0.6,6-1.2,6.8-4.2l3.2-11.9c0.8-3-0.9-6-3.8-7,3-0.3,5.4-2.6,5.4-5.7v-12.4c0.2-3-2.3-5.4-5.3-5.7z---M797.1,753.4c7.5,20.7-10.8,44.5-38.5,35.8-24.4-15.7-18-45,2.7-52.6,14.5-5.2,30.5,2.3,35.8,16.8z M845.6,735.8c-15-41.3-60.7-62.6-101.9-47.5-41.3,15-62.6,60.7-47.5,101.9,15,41.3,60.7,62.6,101.9,47.5,41.2-15,62.5-60.6,47.5-101.9z,m-56,78.8c-28.5,10.4-60-4.3-70.3-32.8-10.4-28.5,4.3-60,32.8-70.3,28.5-10.4,60,4.3,70.3,32.8,10.4,28.4-4.3,59.9-32.8,70.3z M910.4,389.4h42.5v5.4h-42.5z,fill="",M947.8,389.4h5.1v50.5h-5.1z,fill="",M942.4,420.9h8v18.9h-8z,fill="",M165.9,544.2H163c-18.2,0-33.1-14.9-33.1-33.1V345c0-18.2,14.9-33.1,33.1-33.1h2.9c18.2,0,33.1,14.9,33.1,33.1v166c0,18.3-14.9,33.2-33.1,33.2zM342.3,544.2h-2.9c-18.2,0-33.1-14.9-33.1-33.1V345c0-18.2,14.9-33.1,33.1-33.1h2.9c18.2,0,33.1,14.9,33.1,33.1v166c0,18.3-14.9,33.2-33.1,33.2zM516.6,544.2h-2.9c-18.2,0-33.1-14.9-33.1-33.1V345c0-18.2,14.9-33.1,33.1-33.1h2.9c18.2,0,33.1,14.9,33.1,33.1v166c0,18.3-14.9,33.2-33.1,33.2z',
                                symbol: `image://${TruckDataUri}`,
                                symbolSize: 28,
                                symbolKeepAspect: true,
                                itemStyle: { color: '#FF9F38', shadowColor: 'rgba(0, 0, 0, 0.5)', shadowBlur: 3, shadowOffsetX: -1, shadowOffsetY: 2 },
                            })
                        } else {
                            Object.assign(serie, {symbolSize: 28});
                        }
                    }
                });
                if (this.available_days && this.stock.avg_out_stock_in_days){
                    const out_qty = this.available_days * this.stock.avg_out_stock_in_days;
                    series[0].markArea = {
                        label: {
                            textStyle: { color: '#000', fontWeight: 'bold' }
                        },
                        itemStyle: {color: '#FF7D7F', opacity: 0.5},
                        data: [
                            [
                                {
                                    name: `预估 ${this.available_days} 天出库量 ${out_qty}, 库存可售天数 ${this.stock.days_available_for_sale}`,
                                    yAxis: 0
                                },
                                {
                                    yAxis: out_qty
                                }
                            ]
                        ]
                    }
                }
                return series;
            },
            mark_point () {
                return {
                    data: [
                        {
                            symbol: 'diamond',
                            symbolSize: 12,
                            coord: [`${this.today.month}-${this.today.day}`, 0],
                            itemStyle: {
                                color: '#668CFF'
                            }
                        }
                    ]
                }
            },
            chart_extend () {
                return {
                    series: [
                        {
                            label: {show: this.show_label},
                            smooth: false,
                            type: 'line',
                        }
                    ],
                }
            },
        },
        created (){
            this.getStockData();
            this.updateToday();
            // 半小时更新一次
            this.timer = setTimeout(() => {
                this.updateToday();
            }, 1800 * 1000);
        },
        mounted (){
            //
        },
        beforeDestroy () {
            clearTimeout(this.timer);
        },
        methods: {
            updateToday () {
                const now = new Date();
                const month = now.getMonth() + 1;
                const day = now.getDate();
                this.today.month = month;
                this.today.day = day;
            },
            getStockData (){
                if(this.params.years.length === 0){
                    this.params.years = [last_year];
                }
                if (this.loading) return;
                this.loading = true;
                this.$util.ajax.get(this.$util.api.stock_inventory_data, {
                    params: Object.assign({
                        stock_id: this.stock_id
                    }, this.params)
                }).then((response) => {
                    return response.data;
                }).then((res) => {
                    if(res.code === 1){
                        const data = res.data;
                        //this.data_empty = data.records.length === 0;
                        this.stock = data.stock;
                        this.x_axis = data.x_axis;
                        this.ori_series = data.series;
                        this.data_zoom = data.data_zoom;
                        this.changed_data_zoom = this.$util.clone(data.data_zoom);
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e) => {
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(() => {
                    this.loading = false;
                });
            },
            recoveryDataZoom () {
                this.data_zoom = this.changed_data_zoom;
            },
            getOption (o){
                console.log(o._api.getOption());
            }
        }
    }
</script>
